export class ForgotPasswordTO {
    email: string;
    confirmationCode: string;
    password: string;
    firstName: string;
    success: boolean;
    message: string;
}
